// Modules.
import { withRouter } from 'react-router-dom';

// Components.
import Page from './Page';

export default withRouter(Page);
